import React from "react";
import { BreadcrumbItem } from "reactstrap";
import { Route, Switch, Link } from "react-router-dom";
import * as NewRoute from "./new";
import * as ListRoute from "./list";
import * as TableRoute from "./table";
import TablePublicSchema from "@common/schema/table/public";
import * as Section from "@repoflow/components/section";

const LocalProvider = ({
  match: {
    params,
  },
  children: Children,
}) => {
  const base = `/table`;
  const basepath = `/table`;

  return (
    <Section.Provider
      schema={TablePublicSchema}
      base={base}
      basepath={basepath}
      attributes={params}
    >
      {/* Called, never rendered as an element — see Section.Provider, and
          routes.test.js, which scans this directory for both halves. */}
      {Children({ base, basepath, params })}
    </Section.Provider>
  );
};

export function Content(props) {
  return (
    <LocalProvider {...props}>
      {({ basepath }) => (
        <Switch>
          <Route path={`${basepath}/new`} component={NewRoute.Content} />
          <Route path={`${basepath}/:tableId`} component={TableRoute.Content} />
          <Route path={`${basepath}/`} component={ListRoute.Content} />
        </Switch>
      )}
    </LocalProvider>
  );
}

export function Indice(props) {
  return (
    <LocalProvider {...props}>
      {({ base, basepath }) => (
        <>
          <BreadcrumbItem>
            <Link to={base}>Tables</Link>
          </BreadcrumbItem>
          <Switch>
            <Route path={`${basepath}/new`} component={NewRoute.Indice} />
            <Route path={`${basepath}/:tableId`} component={TableRoute.Indice} />
            <Route path={`${basepath}/`} component={ListRoute.Indice} />
          </Switch>
        </>
      )}
    </LocalProvider>
  );
}

export const Sidebar = () => <></>;
